import { isDefined } from "./helpers";
import { Splide } from '@splidejs/splide';

export function initPartner()
{
    const sliderPartner = document.querySelector('.section-partner-content');
    if(!isDefined(sliderPartner)) return;

    let slider_partner = new Splide( sliderPartner, {
        speed : "500",   
        interval : "3000",
        autoplay: true,
        waitForTransition: false,
        pagination: true,
        arrows: false,
        rewind: true,
        pauseOnHover: true,
        pauseOnFocus: false,
        mediaQuery: 'min',
        breakpoints: {
            900: {
                destroy : true,
            }
        }
    })

    slider_partner.mount();

}